module.exports = __webpack_public_path__ + "static/stardust-select-searchable-f3b8b2567c061906c8b7582d22fdd033.png";